import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';

@Component({
  selector: 'rt-placeloader',
  templateUrl: './placeloader.component.html',
  styleUrls: ['./placeloader.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.light]': '!dark()',
    '[class.dark]': 'dark()',
    '[class.short]': 'short()',
    '[class.disable-animations]': 'disableAnimations()',
    '[class]': 'variant()',
  },
  standalone: true,
})
export class PlaceloaderComponent {
  public static readonly VARIANTS: Variants = ['text', ['text', 'item']];
  public readonly variant = input(...ComponentVariantTransform(PlaceloaderComponent.VARIANTS));

  public readonly dark = input<boolean>(false);
  public readonly short = input<boolean>(false);
  public disableAnimations = input(false, { transform: booleanAttribute });
}
